export const countryCodeMap = {
  Indian: "IN",
  Chinese: "CN",
  Japanese: "JP",
  "Thai and Malaysian": "TH",
  Italian: "IT",
  Continental: "FR",
  Mexican: "MX",
  "Middle Eastern": "AE",
  Korean: "KR",
  American: "US",
};